module.exports = __webpack_public_path__ + "img/heptagon-fill.3d4c85f4.svg";